var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUnlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    fill: "none",
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M9.166 19.108l-1.208 1.279c-.634.671-1.481 1.041-2.386 1.041s-1.752-.37-2.386-1.041c-1.316-1.394-1.316-3.663 0-5.057l3.016-3.196c.047-.06.1-.117.157-.167l.23-.243-1.556-1.648-3.403 3.606c-2.173 2.303-2.173 6.05 0 8.353 1.05 1.112 2.45 1.724 3.942 1.724 1.493 0 2.892-.612 3.942-1.724l2.447-2.593c-.191.016-.384.026-.579.026-.764 0-1.509-.124-2.216-.36zM20.37 10.527c2.173-2.303 2.173-6.05 0-8.354C19.32 1.062 17.92.45 16.428.45c-1.493 0-2.893.613-3.942 1.724L10.04 4.767c.191-.016.384-.026.579-.026.764 0 1.509.124 2.216.36l1.207-1.28c.634-.67 1.482-1.04 2.387-1.04s1.752.37 2.386 1.04c1.316 1.395 1.316 3.663 0 5.057l-3.017 3.197c-.046.06-.099.116-.157.166l-1.477 1.566-4.466-4.732c1.138-.34 2.413-.039 3.307.909.4.423.689.947.846 1.52l1.678-1.778c-.256-.509-.58-.98-.969-1.39C13.51 7.224 12.11 6.61 10.617 6.61c-.924 0-1.813.236-2.605.68L1.556.448 0 2.097l6.282 6.656-.004.004 1.555 1.648.004-.004 4.466 4.732-.006.002 1.686 1.786.005-.003 6.457 6.841L22 22.111l-6.282-6.656 4.652-4.928z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M7.44 15.873c1.05 1.112 2.45 1.724 3.942 1.724.238 0 .474-.016.706-.047l-4.256-4.509-1.36 1.441c.256.51.58.98.969 1.39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlink);
export default __webpack_public_path__ + "static/media/icon-unlink.729e18ee.svg";
export { ForwardRef as ReactComponent };